module.exports = __webpack_public_path__ + "img/IMG_9928_L_Wood.203c9ec3.jpg";